import { render, staticRenderFns } from "./BonoExportExcel.vue?vue&type=template&id=6d60c764"
import script from "./BonoExportExcel.vue?vue&type=script&lang=js"
export * from "./BonoExportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports